// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dce2e291","455":"1a2bd2da","977":"3d0aedc9"}[chunkId] + ".chunk.js";
};